import React from "react";

import { AdditionalDescriptionCombination } from "./AdditionalDescriptionCombination";
import { AdditionalDescriptionCombinations } from "./AdditionalDescriptionCombinations";
import { AccStatementBetSlipEventInOffer } from "@data-types/account-statement/AccountStatementBetSlip";

export function AdditionalDescriptionNotSystem(props: {
	slipDetails: AccStatementBetSlipEventInOffer;
}) {
	if ("system" in props.slipDetails! && props.slipDetails.system) {
		return null;
	}
	if (!("totalNumberOfCombinations" in props.slipDetails!)) {
		return null;
	}
	const { totalNumberOfCombinations } = props.slipDetails;
	return (
		<>
			<AdditionalDescriptionCombination
				totalNumberOfCombinations={totalNumberOfCombinations}
			/>
			<AdditionalDescriptionCombinations
				totalNumberOfCombinations={totalNumberOfCombinations}
			/>
		</>
	);
}
